/**
* 入库首页
*/
<template>
	<div style="display: flex;flex-direction: column; height: 89vh;">

		<div style="margin: 0 10px; display: flex;">

			<el-form ref="form" :model="form" label-width="80px">
				<el-form-item label="设备类型">
					<el-select v-model="form.activityRegion" clearable placeholder="请选择入库的设备类型" @change="select">
						<!-- 1 cellmate  pearFlower  3 little devil  4 7 二代锁  6 钥匙盒  5 拍子  9 肛塞 10三代锁 11二代钥匙盒 12尾巴 13金属锁 14脉冲鸟 15震动金属锁 
						16飞机杯 17三代肛塞(无加密) 18三代肛塞(有加密)-->
						<el-option label="三代肛塞(有加密)" value="18"></el-option>
						<el-option label="伪娘锁(CC锁)" value="19"></el-option>
						<el-option label="金属钥匙盒" value="20"></el-option>
						<el-option label="Thrill Cage(OEM锁)" value="21"></el-option>
						<el-option label="silibration_cage(硅胶震动锁)" value="22"></el-option>
						<el-option label="三代肛塞(无加密)" value="17"></el-option>
						<el-option label="飞机杯" value="16"></el-option>
						<el-option label="震动金属锁" value="15"></el-option>
						<el-option label="脉冲鸟" value="14"></el-option>
						<el-option label="金属锁" value="13"></el-option>
						<el-option label="尾巴" value="12"></el-option>
						<el-option label="二代钥匙盒" value="11"></el-option>
						<el-option label="三代锁" value="10"></el-option>
						<el-option label="二代肛塞" value="9"></el-option>
						<el-option label="二代锁(新图标)" value="7"></el-option>
						<el-option label="一代钥匙盒" value="6"></el-option>
						<el-option label="电击拍" value="5"></el-option>
						<el-option label="二代锁(旧图标)" value="4"></el-option>
						<el-option label="小恶魔" value="3"></el-option>
						<el-option label="梨花肛塞" value="2"></el-option>
						<el-option label="一代锁" value="1"></el-option>
					</el-select>
				</el-form-item>
			</el-form>

			<el-form ref="form" :model="form" label-width="80px">
				<el-form-item label="入库时间">
					<el-date-picker v-model="value" type="daterange" @change="selectTime" start-placeholder="开始日期"
						end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']">
					</el-date-picker>
				</el-form-item>
			</el-form>

			<el-form ref="form" :model="form" label-width="80px" style="margin-left: 20px;">
				<el-input placeholder="设备ID搜索" v-model="deviceID" class="input-with-select">
					<el-button slot="append" icon="el-icon-search" @click="selectDeviceID"></el-button>
				</el-input>
			</el-form>

			<el-form ref="form" :model="form" label-width="80px" style="margin-left: 20px;">
				<el-input placeholder="设备编码搜索" v-model="deviceNumber" class="input-with-select">
					<el-button slot="append" icon="el-icon-search" @click="selectDeviceID"></el-button>
				</el-input>
			</el-form>

		</div>


		<!-- 列表 -->
		<el-table v-if="tableData" :data="tableData" height="200" stripe border
			style="width: 100%; flex: 1; overflow: auto;" :default-sort="{ prop: 'createTime', order: 'descending' }">
			<el-table-column type="index" :index="indexMethod"></el-table-column>
			<el-table-column prop="createTime" label="入库时间" align="center" sortable width="170"></el-table-column>
			<el-table-column prop="bluetoothAddress" label="蓝牙地址" align="center" width="150"></el-table-column>
			<el-table-column prop="serialNumber" label="设备编码" align="center" width="180"></el-table-column>
			<el-table-column label="设备类型" align="center" width="100">
				<template slot-scope="scope">
					<div slot="reference" class="name-wrapper">
						<p style="font-size: 13px;">{{ scope.row.typeId }}</p>
					</div>
				</template>
			</el-table-column>
			<el-table-column label="设备名称" align="center" width="130">
				<template slot-scope="scope">
					<div slot="reference" class="name-wrapper">
						<p style="font-size: 14px;">{{ scope.row.toyName }}</p>
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="uid" label="设备ID" align="center" width="100"></el-table-column>
			<el-table-column prop="active" label="是否激活" align="center" width="80"></el-table-column>
			<el-table-column prop="iccid" label="iccid" align="center" sortable></el-table-column>
			<!-- 其他接口的字段也可以添加进来 <el-table-column prop="iccid" label="iccid" :formatter="formatter"></el-table-column> -->

			<el-table-column fixed="right" label="操作" width="100" align="center">
				<template slot-scope="scope">
					<el-button @click="querySimCard(scope.$index)" type="text" size="small">查询sim卡</el-button>
					<!-- <el-button type="text" size="small">编辑</el-button> -->
				</template>
			</el-table-column>

		</el-table>

		<!-- 页码 -->
		<div class="block"
			style="flex-shrink: 0; width: 100%; height: 60px; display: flex; align-items: center; justify-content: center;">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
				:page-sizes="[20, 30, 40,50,100,200]" layout="total, sizes, prev, pager, next, jumper" :total="total">
			</el-pagination>
		</div>

	</div>
</template>

<script>
	import Cookies from 'js-cookie';
	import axios from 'axios';

	export default {
		data() {
			return {
				tableData: null, //数据类型
				form: {
					activityRegion: '', // 根据需要添加其他表单字段
				},
				typeId: 0, //设备类型
				startTime: 0, //开始时间
				endTime: 0, //结束时间
				pageSize: 20, //每页条数
				pageNum: 1, //当前页数
				total: 1, //一共有多少条数据
				whichArticle: 1, //这是第几条
				value: '', //时间
				deviceID: "", //要查询的设备ID
				deviceNumber: "", //要查询的设备编码
				//...
			};
		},
		mounted() {
			this.fetchData(this.pageNum, this.pageSize);
		},
		methods: {
			fetchData(pageNum, pageSize) {
				this.pageSize = pageSize;
				this.pageNum = pageNum;

				const requestData = {};
				requestData.pageSize = pageSize;
				requestData.pageNum = pageNum;

				if (this.typeId != 0) {
					requestData.typeId = this.typeId; //设备类型
				}

				if (this.startTime != 0) {
					requestData.startTime = this.startTime; //开始时间
				}
				if (this.endTime != 0) {
					requestData.endTime = this.endTime; //结束时间
				}

				if (this.deviceID.length != 0) {
					requestData.toyId = this.deviceID; //设备ID
				}
				if (this.deviceNumber.length != 0) {
					requestData.serialNumber = this.deviceNumber; //设备编码
				}

				console.log("入库查询数据发送：", requestData)

				axios.post(this.$p_url + '/charge/4G/iccid/queryIccidDeviceList', requestData, {
						withCredentials: true, // 允许跨域携带 cookie
						headers: {
							'Content-Type': 'application/json', // 设置请求头为 JSON，根据后端要求适当调整
							'Accept': '*/*',
							'token': Cookies.get("token"),
						},
					})
					.then(response => {
						console.log("入库查询数据返回：", response.data)
						const state = response.data.state; // 获取状态
						if (state === "authFailed") { //登录失效
							Cookies.remove("token");
							this.$router.push({ //跳转到登录
								path: '/Login1715',
								query: {}
							});
						}
						if (state === "success") { // 检查状态
							if (response.data.data.list != null) {
								this.total = response.data.data.total; //一共有多少条数据
								for (let i = 0; i < response.data.data.list.length; i++) {
									//修改设备类型 1 cellmate  pearFlower  3 little devil  4 7 二代锁  6 钥匙盒  5 拍子  9 肛塞 10三代锁 11二代钥匙盒 12尾巴 13金属锁
									switch (response.data.data.list[i].typeId) {
										case 19: //伪娘锁(CC锁)
											response.data.data.list[i].typeId = "伪娘锁(CC锁)";
											break
										case 20: //金属钥匙盒
											response.data.data.list[i].typeId = "金属钥匙盒";
											break
										case 21: //Thrill Cage(OEM锁)
											response.data.data.list[i].typeId = "Thrill Cage(OEM锁)";
											break
										case 22: //silibration_cage(硅胶震动锁)
											response.data.data.list[i].typeId = "silibration_cage(硅胶震动锁)";
											break
										case 1:
											response.data.data.list[i].typeId = "一代锁";
											break
										case 2:
											response.data.data.list[i].typeId = "梨花肛塞";
											break
										case 3:
											response.data.data.list[i].typeId = "小恶魔";
											break
										case 4:
											response.data.data.list[i].typeId = "二代锁(旧标)";
											break
										case 5:
											response.data.data.list[i].typeId = "电击拍";
											break
										case 6:
											response.data.data.list[i].typeId = "一代钥匙盒";
											break
										case 7:
											response.data.data.list[i].typeId = "二代锁(新标)";
											break
										case 9:
											response.data.data.list[i].typeId = "二代肛塞";
											break
										case 10:
											response.data.data.list[i].typeId = "三代锁";
											break
										case 11:
											response.data.data.list[i].typeId = "二代钥匙盒";
											break
										case 12:
											response.data.data.list[i].typeId = "尾巴";
											break
										case 13:
											response.data.data.list[i].typeId = "金属锁";
											break
										case 14:
											response.data.data.list[i].typeId = "脉冲鸟";
											break
										case 15:
											response.data.data.list[i].typeId = "震动金属锁";
											break
										case 16:
											response.data.data.list[i].typeId = "飞机杯";
											break
										case 17:
											response.data.data.list[i].typeId = "三代肛塞(无加密)";
											break
										case 18:
											response.data.data.list[i].typeId = "三代肛塞(有加密)";
											break
									}
									//入库时间将时间戳转换为具体的时间
									response.data.data.list[i].createTime = this.formatDate(response.data.data.list[i]
										.createTime);
									//是否激活设备
									if (response.data.data.list[i].active == 1) {
										response.data.data.list[i].active = "已激活"
									} else {
										response.data.data.list[i].active = "未激活"
									}
								}
								this.tableData = response.data.data.list;
							} else {
								this.tableData = [];
							}

						}
					})
					.catch(error => { // 请求失败时处理错误
						console.error('Error fetching data:', error);
					});
			},
			querySimCard(index) { //查询卡
				// this.$router.push({ 
				// 	name: 'WarehouseCare',
				// 	params: {
				// 		iccid: this.tableData[index].iccid,
				// 		mac: this.tableData[index].bluetoothAddress,
				// 	}
				// });
				//跳转操作卡页面 打开新的页面
				const {
					iccid,
					bluetoothAddress
				} = this.tableData[index];
				//console.log('前四个字符', iccid.substring(0, 4));
				if (iccid.substring(0, 4) === '8986') {
					//国内卡
					const routeURL = this.$router.resolve({
						name: 'WarehouseCare_domestic',
						params: {
							iccid,
							mac: bluetoothAddress
						},
					});
					window.open(routeURL.href, '_blank');
				} else {
					//国外卡
					const routeURL = this.$router.resolve({
						name: 'WarehouseCare',
						params: {
							iccid,
							mac: bluetoothAddress
						},
					});
					window.open(routeURL.href, '_blank');
				}
				console.log('查询', this.tableData[index].iccid);
			},
			formatter(row, column) {
				return row.address;
			},
			handleSizeChange(val) { //设置每页多少条
				this.pageSize = val;
				this.fetchData(this.pageNum, val);
			},
			handleCurrentChange(val) { //查询第几页的数据
				this.fetchData(val, this.pageSize);
			},
			select() { //选中了某个值
				this.typeId = this.form.activityRegion;
				this.fetchData(1, this.pageSize);
			},
			selectTime() { //选择了时间
				if (this.value == null) {
					this.startTime = 0;
					this.endTime = 0;
					this.fetchData(1, this.pageSize);
				} else {
					[this.startTime, this.endTime] = this.value;
					// 将时间字符串转换为时间戳
					this.startTime = new Date(this.startTime).getTime();
					this.endTime = new Date(this.endTime).getTime();
					this.fetchData(1, this.pageSize);
				}
			},
			selectDeviceID() { //输入了设备ID进行
				this.fetchData(1, this.pageSize);
			},
			formatDate(timestamp) {
				const date = new Date(timestamp);
				// 获取年月日时分秒
				const year = date.getFullYear();
				const month = (date.getMonth() + 1).toString().padStart(2, '0'); // 补0操作
				const day = date.getDate().toString().padStart(2, '0');
				const hours = date.getHours().toString().padStart(2, '0');
				const minutes = date.getMinutes().toString().padStart(2, '0');
				const seconds = date.getSeconds().toString().padStart(2, '0');

				return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
			},
			indexMethod(index) {
				if (this.pageNum == 1) {
					return index + 1;
				} else {
					return (this.pageNum - 1) * this.pageSize + index + 1;
				}

			},
		},
		//...
	};
</script>
